import { BOOKING_FORM_FIELDS, TICKET_HOLDER_FORM_FIELDS } from '@domain/admission';

export interface DefaultFormFields {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  gender: string;
  nationality: string;
  birth: string;
}

const createField = (field: keyof DefaultFormFields, form: Partial<DefaultFormFields>) => {
  return {
    name: field,
    value: form[field],
  };
};

export const createFieldsFromFormFields = <
  T extends { bookingFormFields: Partial<DefaultFormFields>; ticketHolderFormFields: Partial<DefaultFormFields>[] },
>(
  form: T,
  field: typeof BOOKING_FORM_FIELDS | typeof TICKET_HOLDER_FORM_FIELDS
) => {
  const formFields = form[field];
  if (!formFields) return [];
  if (Array.isArray(formFields)) {
    return formFields.map((fields) =>
      Object.keys(fields)
        .filter((key) => fields[key as keyof DefaultFormFields])
        .map((key) => createField(key as keyof DefaultFormFields, fields))
    );
  } else {
    return Object.keys(formFields)
      .filter((key) => formFields[key as keyof DefaultFormFields])
      .map((key) => createField(key as keyof DefaultFormFields, formFields));
  }
};
